import { useEffect, useState } from 'react';
import { userErrorMessage } from '../../../lib/userErrors';
import { PlanPrices, paidSignupApi } from '../paidSignupApi';

/** Prices the backend charges; `prices` stays `null` until they load. */
export function usePaidSignupPrices() {
    const [prices, setPrices] = useState<PlanPrices | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        paidSignupApi.getPlanPrices()
            .then(result => {
                if (!cancelled) setPrices(result);
            })
            .catch(err => {
                console.error(err);
                if (!cancelled) setError(userErrorMessage(err, 'No pudimos cargar los precios. Recarga la página.'));
            });
        return () => {
            cancelled = true;
        };
    }, []);

    return { prices, error };
}
